module.exports = __webpack_public_path__ + "static/media/cody.63c5836d.svg";